import { eLetterParamsAP } from './AP/ELetterParamsAP'
import { eLetterParamsAR } from './AR/ELetterParamsAR'
import { eLetterParamsCB } from './CB/ELetterParamsCB'
import { eLetterParamsGL } from './GL/ELetterParamsGL'
import { eLetterParamsGP } from './GP/ELetterParamsGP'
import { useGetApprovalPolicyQuery } from 'generated/graphql'

export class ELetterParamsService {
  static ELetterCompanyParams() {
    return [
      // COMPANY PARAMS
      '[CompanyName]',
      '[CompanyRegNo]',
      '[CompanyAddress]',
      '[CompanySSTNo]',
      '[CompanyGSTNo]',
      '[CompanyTelNo]',
      '[DefaultCompanyBankName]',
      '[DefaultCompanyBankAccNo]',
      '[CompanyTIN]',
      '[CompanyCurrencyCode]',
    ]
  }

  static ELetterParamsByModule(
    Module: any,
    Submodule: any,
    ApproverLevel: any
  ) {
    const approvalLevelParams: string[] = []

    if (ApproverLevel > 1) {
      for (let level = 1; level <= ApproverLevel; level += 1) {
        approvalLevelParams.push(
          `[ApprovedBy${level}]`,
          `[ApprovedDate${level}]`
        )
      }
    }

    const eLetterMetadataParams: string[] = [
      // ELETTER METADATA PARAMS
      '[PageNo]',
      '[TotalPage]',
      '[CreatedBy]',
      '[CreatedDate]',
      '[ApprovedBy]',
      '[ApprovedDate]',
      ...approvalLevelParams,
      '[SubmittedBy]',
      '[SubmittedDate]',
    ]

    const eLetterParamsByModule: (
      module: string,
      submodule: string
    ) => string[] = (module, submodule) => {
      switch (module) {
        case 'GENERAL_LEDGER':
          return eLetterParamsGL(submodule)

        case 'CASH_BOOK':
          return eLetterParamsCB(submodule)

        case 'ACC_PAYABLE':
          return eLetterParamsAP(submodule)

        case 'ACC_RECEIVABLE':
          return eLetterParamsAR(submodule)

        case 'GENERAL_PURCHASE':
          return eLetterParamsGP(submodule)
      }
    }

    //========== Exempted Tax Function ==========//
    let useExemptedTaxParams: boolean = false

    switch (Module) {
      case 'ACC_PAYABLE':
        switch (Submodule) {
          case 'INVOICE':
          case 'CREDIT_NOTE':
          case 'DEBIT_NOTE':
            useExemptedTaxParams = true
            break
        }
        break

      case 'ACC_RECEIVABLE':
        switch (Submodule) {
          case 'INVOICE':
          case 'CREDIT_NOTE':
          case 'DEBIT_NOTE':
            useExemptedTaxParams = true
            break
        }
        break

      case 'CASH_BOOK':
        switch (Submodule) {
          case 'PAYMENT':
          case 'RECEIPT':
            useExemptedTaxParams = true
            break
        }
        break

      case 'GENERAL_PURCHASE':
        switch (Submodule) {
          case 'GENERATE_PO_FROM_PR':
          case 'PURCHASE_ORDER':
          case 'GOOD_RECEIVE_NOTE':
          case 'GOOD_RETURN_NOTE':
            useExemptedTaxParams = true
            break
        }
        break

      default:
        break
    }

    const exemptedTaxSummaryParams: string[] =
      useExemptedTaxParams === true
        ? [
            '[ExemptedTaxReason]',
            '[ExemptedTaxCode]',
            '[ExemptedTaxRate]',
            '[ExemptedTaxAmount]',
            '[TotalTaxExemptionAmount]',
          ]
        : []

    let result = [
      ...eLetterParamsByModule(Module, Submodule),
      ...exemptedTaxSummaryParams,
      ...eLetterMetadataParams,
    ]

    return result
  }
}

